export const firebaseStageCredentials = {
  apiKey: 'AIzaSyBN5UjqYURtaCptR2AOtwabbLuDoE7jVgY',
  authDomain: 'splitzero-stage.firebaseapp.com',
  projectId: 'splitzero-stage',
  storageBucket: 'splitzero-stage.firebasestorage.app',
  messagingSenderId: '990923163664',
  appId: '1:990923163664:web:77bea20fe6a58ba8792295'
};
